import Tool, { type IToolActionInput, type IToolAvailableInput } from './Tool';
import { hasLayout, isSimpleSelection, isShape } from '../objects/guards';
import type LayoutBehaviors from '../objects/LayoutBehaviors';
import type FrameBehaviors from '../objects/FrameBehaviors';
import { objectBuilder } from '../utils/componentBuilder';

const firstShape = (objects: fabric.Object[]) => {
  return objects.find(obj => isShape(obj));
};

export default class ToolLayoutAddObject extends Tool {
  static toolName = 'Add shape';

  static action({ selection, controller }: IToolActionInput): void {
    const layout = selection as LayoutBehaviors &
      FrameBehaviors &
      fabric.Object;

    const shape = firstShape(layout.children);
    const pointer = { x: selection.left, y: selection.top };
    let object;

    if (!shape) {
      object = objectBuilder({
        controller,
        object: {
          type: 'shape',
          options: {
            shapeName: 'note',
            ...controller.defaultsManager.defaultFor('shape', 'note'),
          },
        },
        pointer,
      });
    } else {
      // Copy the serialized keys from the shape, removing id and text content
      const copy = shape.toJSON();
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { id, textContent, ...options } = copy;
      object = objectBuilder({
        controller,
        object: { type: 'shape', options },
        pointer,
      });
    }

    object.setParentFrame(layout);

    layout.layout();

    ToolLayoutAddObject.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput): boolean {
    if (!selection) {
      return false;
    }

    // Only available if a single layout is selected
    return !isSimpleSelection(selection) && hasLayout(selection);
  }
}
